export function changeIframe(config, Alpine) {
  return {
    isloaded: false,
    selectValue: "",
    formUrl: config.formUrl || "https://cecforms.tfaforms.net/forms/view/",

    init() {
      const vm = this;

      vm.initFormIframe();
      vm.iframeNavigation();
    },

    iframeNavigation() {
      const iframeWrapper = this.$el.querySelector("iframe");
      const formID = iframeWrapper.dataset.id;

      // console.log(iframeWrapper, "##########################");
      window.addEventListener(
        "message",
        (event) => {
          if (event.data && typeof event.data === "object" && event.data.id && event.data.id === "cec-reso") {
            if (formID !== event.data.message || event.data.message === "next page" || event.data.message === "prev page") {
              // console.log(event.data);

              // console.log(event.data.message);
              const iframeWrapperSection = iframeWrapper.closest("section");
              const offset = iframeWrapperSection.offsetTop - document.querySelector(".js-bottom-header").offsetHeight;
              // console.log(iframeWrapperSection.offsetTop, offset);
              // console.log(iframeWrapperSection.offsetTop - offset);
              window.scrollTo({
                top: offset,
                left: 100,
                behavior: "smooth"
              });
            }
          }
        },
        false
      );
    },

    initFormIframe() {
      const vm = this;
      const appInstance = vm.$root;

      const select = appInstance.querySelector("select");
      const selectValue = select.value;

      if (selectValue !== "") {
        vm.selectValue = selectValue;

        vm.updateIframe();
      } else {
        vm.changeLoadingState();
      }
    },

    updateIframe() {
      const vm = this;
      const appInstance = vm.$root;

      vm.isloaded = false;

      const formIframe = appInstance.querySelector("iframe");
      const newURl = vm.formUrl + vm.selectValue;
      formIframe.src = newURl;

      vm.$nextTick(() => {
        vm.changeLoadingState();
      });
    },

    changeIframeURl() {
      const vm = this;
      vm.updateIframe();
    },

    changeLoadingState() {
      const vm = this;
      const appInstance = vm.$root;

      const formIframe = appInstance.querySelector("iframe");

      window.iFrameResize({ log: false }, `#${formIframe.id}`);
      setTimeout(() => {
        vm.isloaded = true;
      }, 3000);
    }
  };
}
